import { render } from "./ContactsMain.vue?vue&type=template&id=c70ca7be&scoped=true"
import script from "./ContactsMain.vue?vue&type=script&lang=js"
export * from "./ContactsMain.vue?vue&type=script&lang=js"

import "./ContactsMain.vue?vue&type=style&index=0&id=c70ca7be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c70ca7be"]])

export default __exports__